import styled from 'styled-components';

export const Wrapper = styled.section`
    display: flex;
    flex-direction: row;
    gap: 12px;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: 120px;
    gap: 24px;
`;

export const Grouper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const Background = styled.div`
  background-color: #F4F6F8;
  padding: 8px;
  border-radius: 20px;
`;

export const Text = styled.span`
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    margin-top: 8px;
    text-align: center;
`;

